"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var styles_1 = require("@material-ui/core/styles");
var sectionExtenderStyles = styles_1.makeStyles(function (_a) {
    var palette = _a.palette;
    return ({
        icon: {
            height: '25px',
            width: '25px',
        },
        sectionExtenderWrapper: {
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
            marginTop: '10px',
            cursor: 'pointer',
            color: palette.primary.main,
            textAlign: 'center',
        },
        rotatedArrow: {
            transform: 'rotate(180deg)',
        },
    });
}, { name: 'Summary_SectionExtender' });
exports.default = sectionExtenderStyles;
